import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image"
import { AnchorLink } from "gatsby-plugin-anchor-links"

const Intro = (props) =>
{

  const Gradient = styled.div`
  background:  linear-gradient( rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6));
`

  const data = useStaticQuery(graphql`
    query {
      allImageSharp {
        edges {
          node {
            fluid(maxWidth: 3000) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    `)
  return (

    <BackgroundImage id="hero-section" fluid={data.allImageSharp.edges
      .find((element) =>
      {

        if (element.node.fluid.src.split('/').pop() === "hero-image.jpg")
        {
          return element;
        }
        return null;
      }).node.fluid} style={{
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}>
      <Gradient>
        <section class="hero is-fullheight-with-navbar" >

          <div class="hero-body">
            <div class="container fluid">
              <figure>
                <StaticImage
                  src="../images/Logo.png"
                  width={700}
                  quality={100}
                  formats={["AUTO", "WEBP", "AVIF"]}
                  alt="Dutch Tyres"
                />
              </figure>
              <br /><br />
              <p class="subtitle is-4 has-text-white-ter mainfont" >
                {props.description}
              </p>
              <AnchorLink to={props.page + "#intro-section"}>
                <button class="button is-large is-info is-outlined">{props.button}</button>
              </AnchorLink>

            </div>
          </div>
        </section>
      </Gradient>
    </BackgroundImage >
  )

}
export default Intro;